import { Injectable } from '@angular/core';
import { APIService } from './master/api.service';
import { BaseService } from './master/base.service';
import { apiUrl } from '../schema/api-url';
import { Observable } from 'rxjs';
import { AUTH } from 'src/app/constant/constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './master/authentication.service';
@Injectable({
  providedIn: 'root',
})

export class UserService extends BaseService {
  constructor(private _apiService: APIService,
    private authenticationService: AuthenticationService,
    private http: HttpClient) {
    super(_apiService);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Danh sách tài khoản người dùng
   */
  getListUser(requestBody) {
    return super.post(apiUrl.nguoiDung.listUser, requestBody);
  }

  /**
   * @method GET
   * @param
   * @description Thông tin chi tiết người dùng không params
   */
  getInfoUser() {
    return super.get(apiUrl.nguoiDung.userDetail);
  }

  /**
   * @method GET
   * @param tenDangNhap
   * @description Thông tin chi tiết người dùng
   */
  detailedUserInformation(tenDangNhap) {
    return super.get(apiUrl.nguoiDung.detailUserUrl, {
      tenDangNhap: tenDangNhap,
    });
  }

  /**
   * @method GET
   * @param tenDangNhap
   * @description Khôi phục tài khoản người dùng
   */
  userUnlock(tenDangNhap) {
    return super.get(apiUrl.nguoiDung.recoverUser, {
      tenDangNhap: tenDangNhap,
    });
  }

  /**
   * @method DELETE
   * @param tenDangNhap
   * @description Xoá tài khoản người dùng
   */
  userlock(tenDangNhap) {
    return super.delete(apiUrl.nguoiDung.deleteUser, {
      tenDangNhap: tenDangNhap,
    });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param { maTinh, maHuyen, maXa, capDonVi }
   * @description Danh sách đơn vị theo cấp tài khoản
   */
  donViCacCap(maTinh, maXa, maThon, capDonVi) {
    return super.get(apiUrl.danhMuc.dmDonVi, {
      maTinh: maTinh,
      maXa: maXa,
      maThon: maThon,
      capDonVi: capDonVi,
    });
  }

  /**
   * @method GET
   * @param
   * @description Danh sách đơn vị không params
   */
  donViCategory() {
    return super.get(apiUrl.danhMuc.dmDonVi);
  }

  /**
   * @method GET
   * @param maDonVi
   * @description Danh sách phòng ban
   */
  departmentsList(maDonVi) {
    return super.get(apiUrl.danhMuc.dmPhongBan, { maDonVi });
  }

  /**
   * @method POST
   * @param requestBody
   * @description Đăng ký tài khoản người dùng
   */
  registry(requestBody) {
    return super.post(apiUrl.nguoiDung.registryUrl, requestBody);
  }

  /**
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin tài khoản người dùng
   */
  updateUserInfomation(requestBody) {
    return super.put(apiUrl.nguoiDung.updateUserUrl, requestBody);
  }

  /**
   * @method GET
   * @param
   * @description Danh sách nhóm quyền xử lý
   */
  userPermissionList() {
    return super.get(apiUrl.danhMuc.nhomQuyen);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Danh sách lịch sử hoạt động
   */
  getListLog(requestBody) {
    return super.post(apiUrl.nguoiDung.listLog, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param tenDangNhap
   * @description Xoá tài khoản người dùng khỏi database
   */
  deleteAccount(tenDangNhap) {
    return super.delete(apiUrl.nguoiDung.xoaNguoiDung, { tenDangNhap: tenDangNhap });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách hành động do người dùng thưc hiện khi ghi log
   */
  listHanhDongNhatKy() {
    return super.get(apiUrl.nguoiDung.listHanhDong);
  }

  /**
   * @author hangdtt.it5
   * @method downloadFile
   * @param
   * @description Xuất excel danh sách người dùng
   */
  xuatDanhSachNguoiDung(requestBody, nameFile) {
    return super.downloadFile(apiUrl.nguoiDung.xuatDanhSachNguoiDung, nameFile, requestBody );
  }

  /**
   * @author hangdtt.it5
   * @method downloadFile
   * @param
   * @description Xuất excel danh sách nhật ký truy cập
   */
  xuatDanhSachNhatKyTruyCap(requestBody, nameFile) {
    return super.downloadFile(apiUrl.nguoiDung.xuatExcelNhatKyTruyCap, nameFile, requestBody );
  }

  /**
   * @author toitv.tgg
   * @method GET
   * @param
   * @description Danh sách phân quyền menu
   */
  getMenu() {
    return super.get(apiUrl.danhMuc.menu);
  }

  /**
   * @author sonnvt.tgg
   * @method PUT
   * @param
   * @description Cập nhật thông tin người dùng
   */
  updateUserInfo(requestBody) {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');

    const formData = new FormData();
    formData.append("hoTen", requestBody.hoTen);
    formData.append('sdt', requestBody.sdt);
    formData.append('signature', requestBody.signature);

    return this.http.put(apiUrl.nguoiDung.updateUserInfo, formData, { headers });
  }

  upload(data, uuidUser) {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');

    const formData = new FormData();
    formData.append("file", data);
    formData.append('createdBy', uuidUser);

    return this.http.post(apiUrl.GDNN.CAN_BO_QUAN_LY.UPLOAD_ANH_DAI_DIEN, formData, { headers });
}

  /**
   * @author sonnvt.tgg
   * @method POST
   * @param
   * @description Cập nhật thông tin người dùng
   */
   updatePasswordUser(requestBody) {
    return super.post(apiUrl.nguoiDung.updatePasswordUser, requestBody);
  }

  addExpireTokenUser() {
    return super.get(apiUrl.nguoiDung.addExpireToken);
  }
  
  getAnhDaiDien(fileID): Observable<any> {
    let requestOptions = {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders({
            Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            'Content-Type': 'application/json'
        })
    };
    return this.http.get(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_ANH_DAI_DIEN + fileID, requestOptions);
  }

  capNhatAnhDaiDien(requestBody): Observable<any> {
      return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAP_NHAT_ANH, requestBody);
  }


  resetPassword(requestBody) {
    return super.put(apiUrl.nguoiDung.resetPass, requestBody);
  }
  updateDongY(username, isDongY) {
    return super.put(apiUrl.nguoiDung.dongYDieuKhoan + "?username=" + username + "&isDongY=" + isDongY);
  }

  searchLogs(params: {
    blurry?: string;
    logType?: string;
    createTime?: string[];
    page?: number;
    size?: number;
  } ): Observable<any> {
    return this._apiService.get(
      apiUrl.nguoiDung.SYS_LOG.nhatKyHeThong,
      {
        ...params,
        sort:'id,desc'
      }
    );
  }

  errorStackTrace(id:string):Observable<{exception:string}>{
    return this._apiService.get(
      apiUrl.nguoiDung.SYS_LOG.getStackTraceDetail+`/${id}`
    )
  }

  downloadLogs(params: {
    blurry?: string;
    logType?: string;
    createTime?: string[];
  }): Observable<any> {
    return this.http.get(
      apiUrl.nguoiDung.SYS_LOG.taiNhatKyHeThong,
      {
        params: params,
        responseType: 'blob',
        observe: 'body',
        headers:{
          Authorization: 'Bearer ' + this.authenticationService.getToken(),
          'Content-Type': 'application/json',
        }
      }
    );
  }

  registryNguoiDan(requestBody) {
    return super.post(apiUrl.nguoiDung.registryUrlNguoiDan, requestBody);
  }

  capNhatTaiKhoanQLVB(requestBody) {
    return super.post(apiUrl.nguoiDung.capNhatTaiKhoanQLVB, requestBody);
  }

  //Sau sat nhap
  /**
   * @author hangdtt.it5
   * @method GET
   * @param { maTinh, maXa, capDonVi }
   * @description Danh sách đơn vị theo cấp tài khoản
   */
  donViCacCapSauSatNhap(maTinh, maXa, maThon, capDonVi) {
    return super.get(apiUrl.danhMuc.dmDonVi, {
      maTinh: maTinh,
      maXa: maXa,
      maThon: maThon,
      capDonVi: capDonVi,
    });
  }
}
